import _ from "lodash";
import { RESTAURANT_TAG_MAP } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        restaurantTagMap: _.cloneDeep(constants.TAG_MAP_INPUT)
    }
}

const restaurantTagMapReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RESTAURANT_TAG_MAP.SET_RESTAURANT_TAG_MAP_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case RESTAURANT_TAG_MAP.SET_RESTAURANT_TAG_MAP:
        case RESTAURANT_TAG_MAP.SET_RESTAURANT_TAG_MAP_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    restaurantTagMap: action.restaurantTagMap
                }
            })
        default:
            return state
    }
}

export default restaurantTagMapReducer